var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnterpriseNotes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 6A.75.75 0 0 1 6 5.25h6a.75.75 0 1 1 0 1.5H6A.75.75 0 0 1 5.25 6zM6 9.75h6a.75.75 0 1 0 0-1.5H6a.75.75 0 0 0 0 1.5zm3 1.5H6a.75.75 0 1 0 0 1.5h3a.75.75 0 1 0 0-1.5zm9-9.75v10.19a1.49 1.49 0 0 1-.44 1.06l-4.81 4.81a1.49 1.49 0 0 1-1.06.44H1.5A1.5 1.5 0 0 1 0 16.5v-15A1.5 1.5 0 0 1 1.5 0h15A1.5 1.5 0 0 1 18 1.5zm-16.5 15h9.75V12a.75.75 0 0 1 .75-.75h4.5V1.5h-15v15zm11.25-3.75v2.69l2.69-2.69h-2.69z",
    fill: "#696871"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnterpriseNotes);
export default __webpack_public_path__ + "static/media/enterprise-notes.f7a4d12a295f3318cd8185329c2a35fa.svg";
export { ForwardRef as ReactComponent };